import { useState } from "react";
import { useSettings } from "../context/SettingsContext";
import RateSettings from "./RateSettings";
import "./settings.css";

export default function SettingsPanel() {
  const { settings, saveSettings, loading } = useSettings();
  const [saveState, setSaveState] = useState({ status: "idle", message: "" });

  if (loading || !settings) return <p>Loading settings...</p>;

  const handleSave = async () => {
    try {
      setSaveState({ status: "saving", message: "Saving settings..." });
      await saveSettings(settings);
      setSaveState({ status: "success", message: "Settings saved successfully." });
    } catch (err) {
      setSaveState({
        status: "error",
        message: err?.message || "Failed to save settings."
      });
    }
  };

  return (
    <div className="settings-card">

      <h2>System Settings</h2>

      <RateSettings />

      <button className="save-btn" onClick={handleSave}>
        {saveState.status === "saving" ? "Saving..." : "Save All Settings"}
      </button>
      {saveState.message && (
        <p className={`settings-message ${saveState.status}`}>{saveState.message}</p>
      )}

    </div>
  );
}